import React from "react";
import { Spin } from "antd";
import PropTypes from "prop-types";

const Spinner = ({ message, style }) => {
  return (
    <div style={{ textAlign: "center", ...style }}>
      <Spin size={"large"} />
      {message && <p>{message}</p>}
    </div>
  );
};

Spinner.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.jsx